<template>
  <div v-loading="loading" class="body">
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <div v-if="!loading" class="forgotPassword">
              <el-card>
                <el-row type="flex" class="row-bg" justify="end">
                  <LangSelector />
                </el-row>
                <div class="px-4 pb-3">
                  <div class="mainLogoPosition text-center">
                    <img
                      src="@/assets/gregorys_logo.png"
                      style="width: 200px"
                    />
                  </div>
                  <div class="reset-text">
                    <p>{{ $translation('b2b_forgot_pass_text') }}</p>
                  </div>
                  <el-row :gutter="20">
                    <el-form
                      ref="resetPassForm"
                      :model="resetPassForm"
                      :rules="
                        resetPassForm.type == 'phone'
                          ? phoneResetPassRules
                          : emailResetPassRules
                      "
                    >
                      <el-col v-if="resetPassForm.type == 'phone'" :span="8">
                        <el-form-item prop="country_code">
                          <el-select
                            v-model="resetPassForm.country_code"
                            :placeholder="'+30'"
                          >
                            <el-option
                              v-for="type in countryCodeList"
                              :key="type.value"
                              :label="type.label"
                              :value="type.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="resetPassForm.type == 'phone' ? 16 : 24">
                        <el-form-item prop="value">
                          <el-input
                            :placeholder="inputLabel"
                            v-model="resetPassForm.value"
                          >
                            <i
                              slot="prefix"
                              class="el-input__icon"
                              :class="
                                resetPassForm.type === 'email'
                                  ? 'el-icon-message'
                                  : 'el-icon-mobile-phone'
                              "
                            ></i>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-form>
                  </el-row>
                  <el-button
                    type="primary"
                    class="submitButton"
                    :disabled="!isValidForm"
                    @click="onSubmit"
                    >{{ $translation('b2b_send_reset_password') }}</el-button
                  >
                  <p
                    class="text-center pointer resetText mt-4"
                    @click="$router.push('/')"
                  >
                    {{ this.$translation('b2b_back_to_login') }}
                  </p>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import LangSelector from '@/components/LangSelector';
import { isValidEmail, isValidPhoneWithCode } from '@/utils/validate';
import { ForgotPassApi } from '@/utils/echoApi';
export default {
  name: 'ForgotPassword',
  components: {
    LangSelector
  },
  data() {
    const validateInput = (rule, value, callback) => {
      if (this.resetPassForm.type === 'email') {
        if (!isValidEmail(value)) {
          callback(new Error('Please enter a valid email'));
        } else {
          callback();
        }
      } else if (this.resetPassForm.type === 'phone') {
        let countryCode = this.resetPassForm.country_code;
        if (value.length === 0) {
          callback(new Error('Mobile is required'));
        } else if (isNaN(value)) {
          callback(new Error('Mobile must be numeric'));
        } else {
          if (countryCode === 30) {
            if (value.length !== 10) {
              callback(new Error('Mobile must have 10 digits'));
            } else if (!value.startsWith('69')) {
              callback(new Error('Mobile must have 69XXXXXXXX format'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        }
      }
    };
    return {
      loading: true,
      resetPassForm: {
        type: 'phone',
        country_code: 30,
        value: ''
      },
      emailResetPassRules: {
        value: [{ required: true, trigger: 'blur', validator: validateInput }]
      },
      phoneResetPassRules: {
        value: [{ required: true, trigger: 'blur', validator: validateInput }],
        country_code: [{ required: true, trigger: 'change' }]
      }
    };
  },
  computed: {
    ...mapGetters('data', ['hostname']),
    ...mapState('data', {
      Translations: state => state.Translations
    }),
    inputLabel() {
      return this.resetPassForm.type === 'email'
        ? 'example@email.com'
        : 'XXXXXXXXXX';
    },
    isValidForm() {
      return this.resetPassForm.type === 'email'
        ? isValidEmail(this.resetPassForm.value)
        : isValidPhoneWithCode(
          this.resetPassForm.value,
          this.resetPassForm.country_code
        );
    },
    countryCodeList() {
      return [
        {
          label: '+30',
          value: 30
        },
        {
          label: '+40',
          value: 40
        },
        {
          label: '+49',
          value: 49
        },
        {
          label: '+357',
          value: 357
        }
      ];
    }
  },
  created() {
    let _this = this;
    _this.getTranslations().then(function() {
      setTimeout(function() {
        _this.loading = false;
      }, 1000);
    });
  },
  methods: {
    ...mapActions('data', ['getTranslations']),
    setResetPassForm(type) {
      this.resetPassForm.type = type;
      this.resetPassForm.value = '';
      this.resetPassForm.country_code = 30;
      this.$refs['resetPassForm'].clearValidate();
    },
    onSubmit() {
      this.$refs['resetPassForm'].validate(valid => {
        if (valid) {
          this.sendResetPassRequest();
        } else {
          return false;
        }
      });
    },
    sendResetPassRequest() {
      // console.log('resetPassForm:', this.resetPassForm);
      this.$http
        .post('https://' + this.hostname + ForgotPassApi, this.resetPassForm, {
          headers: { Accept: 'application/json' }
        })
        .then(response => {
          if (response.status === 200) {
            this.$message({
              type: response.data.status,
              message: this.$translation(response.data.message)
            });
          }
        })
        .catch(error => {
          this.$message({
            type: error.response.data.status,
            message: this.$translation(error.response.data.message)
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  background: url(../assets/images/main-image.jpg) center top / cover no-repeat;
  background-attachment: fixed;
  height: 100vh;
}

.forgotPassword {
  display: block;
  margin: 15vh auto 0;
  width: 500px;
}

.reset-text {
  text-align: center;
}

.resetOptionsList {
  padding: 0;
  margin: 30px 0 40px;
  list-style: none;
  display: flex;
  justify-content: center;
}

.resetOptionsList > li {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  font-size: 42px;
  height: 80px;
  width: 80px;
  background-color: #f4f4f4;
  border-radius: 40px;
  cursor: pointer;
  box-sizing: border-box;
}

.resetOptionsList > li.active {
  color: white;
  background-color: var(--main-color);
}

.el-input__icon {
  font-size: 22px;
  padding-left: 12px;
}

.submitButton {
  transition: all 0.3s ease-in-out;
  width: 100%;
}

.submitButton.is-disabled {
  background-color: gray !important;
}

@media (max-width: 530px) {
  .forgotPassword {
    margin: 0 auto;
    width: 400px;
  }
}
@media (max-width: 435px) {
  .forgotPassword {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue